import React, { useEffect, useState, useRef } from "react";
import useHttp from "../../../../hooks/use-http";
import Pagination from "../../../../components/Pagination";
import Modal from "react-modal";
import { toast } from "react-toastify";
import { Modal as AntModal, Spin } from "antd";
import html2pdf from "html2pdf.js";

const PurchaseOrderListview = (props) => {
  const [deleteLoading, setDeleteLoading] = useState(false);

  const [loading, setLoading] = useState({
    approve: false,
    disapprove: false,
    sendNextApprove: false,
  });

  const pdfContainerRef = useRef(null);
  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      zIndex: 1000,
    },
    content: {
      top: "55%",
      left: "60%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "900px", // Adjust the width as needed
      height: "80%",
      minHeight: "400px",
      overflow: "auto",
      // border: "5px solid #96dc00",
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (data) => {
    //  //console.log(data);

    const id = data && data.purchaseOrderId;
    if (id) {
      getPurchase(
        {
          url: `/api/purchaseOrder/?orgId=${localStorage.getItem(
            "orgId"
          )}&purchaseOrderId=${id}`,
        },
        (res) => {
          if (res) {
            // //console.log(res);
            setSelectedData(res);
          }
        }
      );
    }

    setIsModalOpen(true);
  };

  const { addForm, update, sId } = props;
  const [data, setData] = useState([]);
  const [pdfView, setPdfView] = useState(false);
  const [allData, setAllData] = useState([]);

  const [pdfData, setPdfData] = useState([]);

  const { sendRequest: getPurchase } = useHttp();

  const getData = () => {
    getPurchase(
      {
        url: `/api/purchaseOrder/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          const sortedData = res.output.sort(
            (a, b) => b.purchaseOrderId - a.purchaseOrderId
          );
          console.log(res);
          setData(sortedData);
          setAllData(res.output);
        }
      }
    );
  };

  useEffect(() => {
    getData();
  }, []);

  const viewPdf = (id) => {
    setPdfView(true);

    if (id) {
      getPurchase(
        {
          url: `/api/purchaseOrder/?orgId=${localStorage.getItem(
            "orgId"
          )}&purchaseOrderId=${id}`,
        },
        (res) => {
          if (res) {
            setPdfData(res);
            console.log(res);
          }
        }
      );
    }
  };

  const handleSearch = (e) => {
      var filetrtext = e.target.value.trim().toLowerCase();

    var filterdata = allData.filter(
      (item) =>
        item.docNo.includes(filetrtext) || item.vendorName.includes(filetrtext)
    );

   setData(filterdata); 
                                
setCurrentPage(1);
  };

  const { sendRequest: orderDelete } = useHttp();

  const handleDelete = (e, purchaseOrderId) => {
    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this Purchase Order detail?",
      onOk() {
        setDeleteLoading(true);

        const input = {
          purchaseOrderId: purchaseOrderId,
          orgId: localStorage.getItem("orgId"),
          createdBy: parseInt(localStorage.getItem("id")),
          serviceId: serviceId,
        };

        orderDelete(
          {
            url: "/api/purchaseOrder/",
            method: "DELETE",
            body: input,
          },
          (data) => {
            toast.success("Data Deleted Successfully");
            getData();
            setDeleteLoading(false);
          },
          (error) => {
            console.error("Error", error);
            toast.error("Data Not Deleted");
            setDeleteLoading(false);
          }
        );
      },
      onCancel() {
        setDeleteLoading(false);
      },
    });
  };

  const [loginUserId, setLoginUserId] = useState(localStorage.getItem("id"));
  const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");

  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        console.log(itemselected);

        setServiceId(itemselected.serviceId);
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const [selectedPurchaseOrder, setSelectedPurchaseOrder] = useState(null);
  const [approvalPopupVisible, setApprovalPopupVisible] = useState(false);

  const [remark, setRemark] = useState("");

  const { sendRequest: updateApprovalStatus } = useHttp();

  const showApprovalPopup = (expense) => {
    // console.log(expense);
    setSelectedPurchaseOrder(expense);
    setApprovalPopupVisible(true);
  };

  const handleRemarkChange = (e) => {
    setRemark(e.target.value);
  };

  const handleApprovalSubmit = (status) => {
    const approvalStatus = status || "";
    // console.log(approvalStatus);

    setLoading((prevState) => ({ ...prevState, [status]: true }));
    let data = "";
    const getApprovalData = (approvalStatus) => {
      const baseData = {
        purchaseOrderId: selectedPurchaseOrder?.purchaseOrderId,
        approvedBy: parseInt(localStorage.getItem("empId")),
        serviceId: serviceId,
        nextlevel: 0,
        orgId: localStorage.getItem("orgId"),
        remark: remark,
      };
    
      switch (approvalStatus) {
        case "approve":
          return { ...baseData, approved: 1 };
        case "disapprove":
          return { ...baseData, approved: 2 };
        case "sendNextApprove":
          return { ...baseData, approved: 0, nextlevel: 1 };
        default:
          return baseData;
      }
    };
    
    data = getApprovalData(approvalStatus);

    // console.log(data);

    updateApprovalStatus(
      {
        url: "/api/approvePurchaseOrder/",
        method: "PUT",
        body: data,
      },
      (data) => {
        toast.success(data);
        setLoading({
          approve: false,
          disapprove: false,
          sendNextApprove: false,
        });
        setApprovalPopupVisible(false);
        setRemark("");
        getData();
      },
      () => {
        setLoading({
          approve: false,
          disapprove: false,
          sendNextApprove: false,
        });
      }
    );
  };

  const printPdfContainer = () => {
    const elementsToHide = document.querySelectorAll(".no-print");
    elementsToHide.forEach((element) => {
      element.style.display = "none !important";
    });
    window.print();
    elementsToHide.forEach((element) => {
      element.style.display = "";
    });
  };

  const generatePDF = (docNo) => {
    const input = pdfContainerRef.current;
    const pdfName = docNo || "purchase order";

    // html2canvas(input, { scale: 3 }).then((canvas) => {
    //   const imgData = canvas.toDataURL("image/png");
    //   const pdf = new jsPDF({
    //     orientation: "p",
    //     unit: "pt",
    //     format: [canvas.width / 4, canvas.height / 4],
    //   });
    //   pdf.addImage(imgData, "PNG", 0, 0, canvas.width / 4, canvas.height / 4);
    //   pdf.save(`${pdfName}.pdf`);
    // });
    html2pdf(input, {
      margin: 10,
      filename: `${pdfName}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "pt", format: "a4", orientation: "portrait" },
      pagebreak: { mode: "avoid-all" },
    });
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row m-1">
          <div className="col-6">
            <label className="card-title mx-3 my-3">Purchase Order</label>
          </div>

          <div className="col-6 text-right">
            {canAdd === "block" && (
              <button
                type="button"
                className="btn  btn-primary mx-3 my-3"
                onClick={() => {
                  addForm(true);
                  sId(serviceId);
                  props.update(false);
                }}
              >
                Add Purchase Order
              </button>
            )}
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-4"> </div>

                      <div className="col-4">
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                          placeholder="Search..."
                        />
                      </div>
                    </div>
                    <br />
                    <table className="table table-bordered table-responsive">
                      <thead>
                        <tr>
                          <th>Order Date</th>
                          <th>Purchase Order No</th>
                          <th>Vendor Name</th>
                          <th>Contact Person Name</th>
                          <th>Total Purchase Cost/Value</th>
                          <th>Currency</th>
                          <th>Goods Reciept</th>
                          <th>Invoice Status</th>
                          <th>Goods Return</th>
                          <th>Assign Employee</th>
                          <th>Approval</th>
                          <th>Approved by</th>

                          {/* {canView === "block" && <th>View</th>} */}

                          {canEdit === "block" && <th>Edit</th>}
                          {canDelete === "block" && <th>Delete</th>}
                          {canPdf === "block" && <th>View</th>}
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i}>
                                <td>{itm.purchaseOrderDate}</td>
                                <td>{itm.docNo}</td>
                                <td>{itm.vendorName}</td>
                                <td>{itm.contactPersonName}</td>
                                <td>{itm.totalPurchase}</td>
                                <td>{itm.currencyCode}</td>
                                <td>{itm.isGoodReciept}</td>
                                <td>{itm.invoiceStatus}</td>
                                <td>{itm.goodsReturn}</td>
                                <td>{itm.employeeName}</td>

                                <td>
                                  <button
                                    className="btn"
                                    type="button"
                                    onClick={() => showApprovalPopup(itm)}
                                    disabled={
                                      itm.nextlevel == 1
                                        ? itm.allowApproveUserId == loginUserId
                                          ? false
                                          : true
                                        : itm.approved == 0 &&
                                          itm.reportingId == loginUserId
                                        ? false
                                        : true
                                    }
                                  >
                                    {itm.approved == 1 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "green" }}
                                      ></i>
                                    ) : itm.approved == 2 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "red" }}
                                      ></i>
                                    ) : (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "gray" }}
                                      ></i>
                                    )}
                                  </button>
                                </td>

                                <td>{itm.approvedByName}</td>

                                {canEdit === "block" && (
                                  <td>
                                    <button
                                      onClick={() => {
                                        props.addForm(true);
                                        props.update(itm);
                                      }}
                                      className="btn"
                                      disabled={
                                        itm.approved == 0 ? false : true
                                      }
                                    >
                                      <i className="fas fa-edit"></i>
                                    </button>
                                  </td>
                                )}

                                {canDelete === "block" && (
                                  <td>
                                    <button
                                      type="button"
                                      onClick={(e) =>
                                        handleDelete(e, itm.purchaseOrderId)
                                      }
                                      className="btn"
                                      disabled={deleteLoading}
                                    >
                                      {deleteLoading ? (
                                        <Spin size="small" />
                                      ) : (
                                        <i className="fa fa-trash"></i>
                                      )}
                                    </button>
                                  </td>
                                )}

                                {canPdf === "block" && (
                                  <td>
                                    <button
                                      type="button"
                                      onClick={() =>
                                        viewPdf(itm.purchaseOrderId)
                                      }
                                      className="btn"
                                    >
                                      <i className="fas fa-eye"></i>
                                    </button>
                                  </td>
                                )}
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <AntModal
        title="Purchase Order Approval"
        open={approvalPopupVisible}
        onCancel={() => setApprovalPopupVisible(false)}
        footer={null}
      >
        <label>Remarks:</label>
        <textarea
          rows={3}
          value={remark}
          className="form-control"
          onChange={handleRemarkChange}
        />
        <br />
        <div>
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => handleApprovalSubmit("approve")}
            disabled={
              loading.approve ||
              loading.disapprove ||
              loading.sendNextApprove
            }
          >
            {loading.approve ? "Approving..." : "Approve"}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            onClick={() => handleApprovalSubmit("disapprove")}
            className="btn btn-sm btn-primary"
            disabled={
              loading.approve ||
              loading.disapprove ||
              loading.sendNextApprove
            }
          >
            {loading.disapprove ? "Disapproving..." : "Disapprove"}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => handleApprovalSubmit("sendNextApprove")}
            disabled={
              loading.approve ||
              loading.disapprove ||
              loading.sendNextApprove
            }
          >
            {loading.sendNextApprove ? "Sending..." : "Send Next Approve"}
          </button>
        </div>
      </AntModal>
      {/* view modal */}
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        {selectedData && (
          <div className="mx-3">
            <h4 className="card-title">Purchase Order Details</h4>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setIsModalOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>

            <div className="row">
              <p className="col-md-6">
                Purchase Order No: {selectedData.docNo}
              </p>
              <p className="col-md-6">
                Purchase Order Date : {selectedData.purchaseOrderDate}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">vendor Name: {selectedData.vendorName}</p>

              <p className="col-md-6">
                Contact Person Name : {selectedData.contactPersonName}
              </p>
            </div>

            <div className="row">
              <p className="col-md-6">
                Assign Employee: {selectedData.employeeName}
              </p>
              <p className="col-md-6">
                Goods Reciept Status: {selectedData.isGoodReciept}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Invoice Status: {selectedData.invoiceStatus}
              </p>
              <p className="col-md-6">
                Goods Return Status: {selectedData.goodsReturn}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Expected Delivery Date: {selectedData.expectedDeliveryDate}
              </p>
              <p className="col-md-6">Terms : {selectedData.terms}</p>
            </div>
            <div className="row">
              <p className="col-md-6">
                BillingAddress: {selectedData.billingAddress} ,
                {selectedData.billingCity}, {selectedData.billingState},{" "}
                {selectedData.billingCountry}, {selectedData.billingZip}.
              </p>
              <p className="col-md-6">
                Shipping Address: {selectedData.shippingAddress},
                {selectedData.shippingCity}, {selectedData.shippingState},{" "}
                {selectedData.shippingCountry}, {selectedData.shippingZip}.
              </p>
            </div>

            <h5>Product Details</h5>
            <table className="table table-bordered table-sm text-center">
              <thead>
                <tr>
                  <th>Sr. No</th>

                  <th>Item Category</th>
                  <th>Item Description</th>
                  <th>Item Unit Price</th>
                  <th>Rate</th>
                  <th>Item Quantity</th>
                  <th>Unit</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {selectedData.productData &&
                  selectedData.productData.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>

                        <td>{itm.productSubTypeName}</td>
                        <td>{itm.productName}</td>
                        <td>{itm.itemUnitPrice}</td>
                        <td>{itm.rate}</td>
                        <td>{itm.orderQuantity}</td>
                        <td>{itm.unitName}</td>
                        <td>{itm.lineAmount}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
            <div className="row">
              <p className="col-md-4">
                Sub-total Amount: {selectedData.lineTotalAmount}
              </p>
              <p className="col-md-4">
                Discount(%) : {selectedData.discountPercentage}
              </p>
              <p className="col-md-4">
                Discounted Amount: {selectedData.discountAmount}
              </p>
            </div>
            <div className="row">
              <p className="col-md-4">
                Total Amount: {selectedData.totalAmount}
              </p>
              <p className="col-md-4">Tax : {selectedData.taxName}</p>
              <p className="col-md-4">Tax Amount: {selectedData.taxAmount}</p>
            </div>
            <div className="row">
              <p className="col-md-4">
                frieght Charges: {selectedData.frieghtCharges}
              </p>
              <p className="col-md-4">
                Order Total Value : {selectedData.totalPurchase}
              </p>
              <p className="col-md-4">Currency: {selectedData.currencyName}</p>
            </div>
          </div>
        )}
      </Modal>
      {pdfView && (
        <Modal isOpen={true} style={customModalStyles}>
          <div className="pdf-main-container ">
            <div className="row no-print">
              <div className="col-md-11"></div>
              <div className="col-md-1">
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="remove"
                    onClick={() => setPdfView(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                </div>
              </div>
            </div>

            <div className="pdf-container mx-3 my-4" ref={pdfContainerRef}>
              <section className="content">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-12">
                      {/* Main content */}
                      <div className="invoice p-3 mb-3">
                        {/* title row */}
                        <div className="row">
                          <div className="col-12">
                            <h4>
                              <img
                                src={`${process.env.REACT_APP_FILE_URL}${
                                  pdfData && pdfData.organizationIcon
                                }`}
                                width="50"
                                height="50"
                                alt="logo"
                              />
                              &nbsp;Purchase Order
                            </h4>
                          </div>
                          {/* /.col */}
                        </div>
                        {/* info row */}
                        <div className="row invoice-info">
                          <div className="col-sm-4 invoice-col">
                            From
                            <address>
                              <strong>{pdfData && pdfData.orgName}</strong>
                              <br />
                              {pdfData && pdfData.orgCity}{" "}
                              {pdfData && pdfData.orgState}
                              <br />
                              {pdfData && pdfData.orgCountry}{" "}
                              {pdfData && pdfData.orgzipCode}
                              <br />
                              Phone: {pdfData && pdfData.orgPhoneNumber}
                              <br />
                              Email: {pdfData && pdfData.orgEmail}
                            </address>
                          </div>
                          {/* /.col */}
                          <div className="col-sm-4 invoice-col">
                            To
                            <address>
                              <strong>{pdfData && pdfData.vendorName}</strong>
                              <br />
                              {pdfData && pdfData.vendorCity}{" "}
                              {pdfData && pdfData.vendorState}
                              <br />
                              {pdfData && pdfData.vendorCountry}{" "}
                              {pdfData && pdfData.vendorzipCode}
                              <br />
                              Phone: {pdfData && pdfData.vendorcontactWork}
                              <br />
                              Email: {pdfData && pdfData.vendoremail}
                            </address>
                          </div>
                          {/* /.col */}
                          <div className="col-sm-4 invoice-col">
                            <br />
                            <b>Order Date:</b>{" "}
                            {pdfData && pdfData.purchaseOrderDate}
                            <br />
                            <b>Order ID:</b> {pdfData && pdfData.docNo}
                            <br />
                            <b>Currency:</b> {pdfData && pdfData.currencyName}
                            <br />
                            <b>Expected Delivery:</b>
                            {pdfData && pdfData.expectedDeliveryDate}
                            <br />
                          </div>
                          {/* /.col */}
                        </div>
                        {/* /.row */}
                        {/* Table row */}
                        <div className="row">
                          <div className="col-12 table-responsive">
                            <table className="table table-striped table-bordered">
                              <thead>
                                <tr>
                                  <th>Sr.No</th>
                                  <th>Item Category</th>
                                  <th>Item Description</th>
                                  <th>Item Unit Price</th>
                                  <th>Rate</th>
                                  <th>Quantity</th>
                                  <th>Unit</th>
                                  <th>Amount</th>
                                </tr>
                              </thead>
                              <tbody>
                                {pdfData.productData &&
                                  pdfData.productData.map((itm, i) => {
                                    return (
                                      <tr key={i}>
                                        <td>{i + 1}</td>

                                        <td>{itm.productSubTypeName}</td>
                                        <td>{itm.productName}</td>
                                        <td>{itm.itemUnitPrice}</td>
                                        <td>{itm.rate}</td>
                                        <td>{itm.orderQuantity}</td>
                                        <td>{itm.unitName}</td>
                                        <td>{itm.lineAmount}</td>
                                      </tr>
                                    );
                                  })}
                              </tbody>
                            </table>
                          </div>
                          {/* /.col */}
                        </div>
                        {/* /.row */}
                        <div className="row">
                          <div className="col-6">
                            <p className="text-muted well well-sm shadow-none">
                              Remark/Note:
                            </p>
                            <p> {pdfData && pdfData.remark}</p>
                            <hr />
                            <p
                              className="text-muted well well-sm shadow-none"
                              style={{ marginTop: 10 }}
                            >
                              Name of Authorized Signatory:
                            </p>
                            <hr />
                            <p
                              className="text-muted well well-sm shadow-none"
                              style={{ marginTop: 10 }}
                            >
                              Amount Chargeable:{" "}
                            </p>
                            <p> {pdfData && pdfData.amountChargeable}</p>
                            <hr />
                            <p
                              className="text-muted well well-sm shadow-none"
                              style={{ marginTop: 10 }}
                            >
                              This is Computer Generated Document
                            </p>
                          </div>

                          <div className="col-6">
                            <div className="table-responsive">
                              <table className="table">
                                <tbody className="text-right">
                                  <tr>
                                    <th style={{ width: "50%" }}>Subtotal:</th>
                                    <td>
                                      {" "}
                                      {pdfData && pdfData.lineTotalAmount}
                                    </td>
                                  </tr>

                                  <tr>
                                    <th style={{ width: "50%" }}>
                                      Discount:(
                                      {pdfData && pdfData.discountPercentage}%)
                                    </th>
                                    <td>
                                      {" "}
                                      {pdfData && pdfData.discountAmount}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th style={{ width: "50%" }}>
                                      Total Amount:
                                    </th>
                                    <td> {pdfData && pdfData.totalAmount}</td>
                                  </tr>
                                  <tr>
                                    <th>
                                      Tax Amount (
                                      {pdfData && pdfData.taxPercentage}%)
                                    </th>
                                    <td> {pdfData && pdfData.taxAmount}</td>
                                  </tr>
                                  <tr>
                                    <th>Frieght Charges :</th>
                                    <td>
                                      {" "}
                                      {pdfData && pdfData.frieghtCharges}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>Total Cost:</th>
                                    <td> {pdfData && pdfData.totalPurchase}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
          <div className="row no-print">
            <div className="col-12">
              <button
                type="button"
                className="btn btn-primary float-right generate-pdf-button"
                style={{ marginRight: 5 }}
                onClick={() => generatePDF(pdfData && pdfData.docNo)}
              >
                <i className="fas fa-download" /> Generate PDF
              </button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default PurchaseOrderListview;
